<template>
  <div>
    <template v-if="count">
      <div v-for="item in list" :key="`integral-${item.id}`" class="item-box">
        <template v-for="updateType in integralUpdateTypes">
          <template v-if="item.update_type === updateType.value">
            <div :key="`${item.id}-${updateType.value}-icon`" class="icon-box">
              <v-icon :name="updateType.icon"/>
            </div>
            <div :key="`${item.id}-${updateType.value}-content`" class="item-content border-bottom">
              <div class="record-list-item flex-justify-between">
                <div class="record-list-title">
                  {{ updateType.name }}
                </div>
                <div class="time accent-color">{{ item.add_time | timeToYmdHi }}</div>
              </div>
              <div class="record-list-item">
                <template v-if="item.course">
                  课程：「{{item.course.course_name}}」；老师：「{{item.course.teacher_names}}」；
                </template>

                <template v-else-if="item.card">
                  课卡：「{{item.card.card_name}}」；
                  实际付款：「{{item.card.actual_payment | toYuan }} 元」；
                </template>

                <template v-if="item.increment_integral > 0">
                  赠送积分：「{{ item.increment_integral | toYuan }} 分」；
                  过期时间：「{{ item.expire_time | timeToYmdHis }}」；
                  此记录当前剩余积分：「
                  <template v-if="item.surplus > 0"><span class="success-color">{{ item.surplus | toYuan }}</span> 分</template>
                  <span v-else class="info-color">已用完</span>
                  」；
                </template>

                <template v-else>
                  扣除积分：「{{ -item.increment_integral | toYuan }} 分」；
                </template>
                用户总剩余积分：「{{ item.integral | toYuan }} 分」。
              </div>
              <div class="store-name info-color">
                操作者：{{ item.administrator_name ? item.administrator_name : '本人' }}
              </div>
            </div>
          </template>
        </template>
      </div>

      <div class="pagination-box">
        <el-pagination
          :background="true"
          :current-page.sync="page"
          :page-size.sync="size"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="pageSizes"
          :total="count"
          @size-change="handlePageChange"
          @current-change="handlePageChange"
        />
      </div>
    </template>
    <div v-else class="empty-tip-box">暂无积分变动记录</div>
  </div>
</template>

<script>
import scrollTo from "@/utils/scroll-to";
import { index } from "@/api/integral-update-record";
import integralUpdateTypes from "@/enums/integralUpdateTypes";

export default {
  props: {
    studentId: Number,
  },
  data: () => ({
    integralUpdateTypes,
    list: [],
    count: 0,
    page: 1,
    size: 8,
    pageSizes: [10, 20, 30],
  }),
  methods: {
    async getList() {
      const { isError, data } = await index({
        student_id: this.studentId,
        page: this.page,
        size: this.size,
      });
      if (isError) return;

      this.list = data.list;
      this.count = data.count;
    },
    handlePageChange() {
      this.getList();
      scrollTo(0, 350);
    },
  },
  beforeMount() {
    this.getList();
  },
};
</script>

<style src="@/components/student-detail-record.css" scoped/>
